module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_normal_red-cef27374b7f8007b6470af728cb69529.svg";